
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.695 15.117l6.531-6.344L15.5 6l-6.625 6.296 2.82 2.82zM10.27 16.52l-2.828-2.829-.446.446v2.828h2.829l.445-.445zm2.122.707l-1.415 1.414a1 1 0 01-.63.29H6.116c-.612.047-1.132-.306-1.085-.917v-4.4a1 1 0 01.29-.63l2.12-2.121.018.017 6.909-6.578a1.6 1.6 0 012.263 0l3.292 3.338a1.6 1.6 0 010 2.263l-7.531 7.324z","fill":"currentColor"}})])
          )
        }
      }
    